<template>
	<router-link :class="['brand', { 'brand-inverse': inverse }]" to="/" aria-label="Paydeck India, home">
		<img class="brand-icon" src="/brand/paydeck-icon-rounded.png" alt="" width="1024" height="1024" />
		<span class="brand-name">Paydeck<span class="brand-period">.</span></span>
	</router-link>
</template>

<script setup>
// Logo lockup: rounded orange icon + "Paydeck." set in type (the full stop stays orange).
// `inverse` is for dark backgrounds (footer): the name turns white.
defineProps({ inverse: { type: Boolean, default: false } });
</script>
